module.exports = __webpack_public_path__ + "assets/img/img-photo-01.1ea91b5d.png";